import {Jobs, Description, CompanySummary, Values} from "@/pages/buddy/company/blocks";
import React, {useMemo} from "react";
import {CompanyDetailsData} from "@/pages/buddy/types/CompanyDetailsData";
import {CompanyDetails} from "@/pages/buddy/company/blocks/CompanyDetails.tsx";
import {Files} from "@/components/file/Files.tsx";
import {LLMLog} from "@/pages/buddy/shared/debug/llm_log.tsx";
import {ChatConfig, SidebarChat} from "@/layouts/buddy";

interface CompanyContentProps {
    company: CompanyDetailsData;
    activePage: string;
    loading: boolean;
    setActivePage: (page: string) => void;
    handleSummaryFetched: (activeJobs: number) => void;
    onCpsUpdateComplete: () => void;
}

const CompanyContent: React.FC<CompanyContentProps> = ({
                                                           company,
                                                           activePage,
                                                           loading,
                                                           setActivePage,
                                                           handleSummaryFetched,
                                                           onCpsUpdateComplete
                                                       }) => {

    const chatConfig: ChatConfig = useMemo(() => ({
        entityType: 'company',
        entityId: company.p_id,
        title: 'Refine This Company Profile',
        instructions: 'Give Buddy your instructions to tailor this company profile to your needs - quickly, clearly, and effortlessly.'
    }), [company.p_id]);

    const renderOverview = () => (
        <>
            {/* ✅ Pass refresh handler to SidebarChat */}
            <SidebarChat config={chatConfig} onUpdateComplete={onCpsUpdateComplete} />

            <CompanySummary setActivePage={setActivePage} onSummaryFetched={handleSummaryFetched}/>
            <Description title="Description" description={company.description || ""} company_p_id={company.p_id}/>
            <div className="grid lg:grid-cols-3 gap-5 lg:gap-7.5">
                <div className="lg:col-span-1">
                    <div className="mb-7.5">
                        <Values title="Values" items={company.values} company_p_id={company.p_id}/>
                    </div>
                </div>
                <div className="lg:col-span-2">
                    <div className="mb-7.5">
                        <CompanyDetails title="Details" company={company} company_p_id={company.p_id}/>
                    </div>
                    <div className="mb-7.5">
                        <Files title="Files" items={company.files}/>
                    </div>
                </div>
            </div>

            <LLMLog
                title="LLM Logs (Dev/Testing Only)"
                llmLogs={company.llm_log || []}
            />
        </>
    );

    // Render the matches section
    const renderJobs = () => (
        <div className="col-span-1 lg:col-span-3">
            <Jobs/>
        </div>
    );

    return (
        <div className="grid grid-cols-1 gap-5 lg:gap-7.5">
            {activePage === 'overview' ? renderOverview() : renderJobs()}
        </div>
    );
};

export {CompanyContent};
